import { Component, Input } from '@angular/core';
import { NgIf, NgStyle } from '@angular/common';

@Component({
    selector: 'app-dual-info-component',
    templateUrl: './dual-info-component.component.html',
    styleUrls: ['./dual-info-component.component.css'],
    standalone: true,
    imports: [NgStyle, NgIf]
})
export class DualInfoComponentComponent {

  @Input() tituloPrincipal = '';
  @Input() infoPrincipal = '';
  @Input() tituloSecundario = '';
  @Input() infoSecundario = '';
  @Input() centralizarTexto: boolean = true
  @Input() roteiroCrossdocking: boolean = false;
}
